<script>
  export default {
    props: {
      google: {
        type: Object,
        required: true
      },
      map: {
        type: Object,
        required: true
      },
      marker: {
        type: Object,
        required: true
      }
    },
    mounted() {
      const { Marker, Polygon } = this.google.maps;
      let icon_aux={
        url: this.marker.icon,
        scaledSize: new google.maps.Size(this.marker.size.width, this.marker.size.height), // scaled size
        // Origin: new google.maps.Point(0,0), // Origin
        // anchor: new google.maps.Point(0, 0) // anchor
      }
      let marcador = new Marker({
        position: this.marker.position,
        marker: this.marker,
        icon:icon_aux,
        map: this.map,
        draggable:false,
        title: this.marker.title
      });

      // console.log(this.marker.jurisdiccion)
      // let triangleCoords=[
      //   {lat: -15.87361444, lng:-69.32001889},
      //   {lat:-16.20055, lng:-68.60288722},
      //   {lat:-16.18197528, lng:-68.79069}
      // ]
      
      let color=Math.floor(Math.random()*16777215).toString(16);

      // indicamos el poligono de trabajo
      let polygon = new Polygon({
        paths: this.marker.jurisdiccion,
        strokeColor: `#${color}`,
        strokeOpacity: 0.8,
        strokeWeight: 1,
        fillColor: `#${color}`,
        fillOpacity: 0.35,
      })

      polygon.setMap(this.map);

      let description= new google.maps.InfoWindow({
        content:this.marker.description
      })
      let that=this;
      marcador.addListener('click', function(){
        description.open(that.map, marcador)
      })
    },
    methods:{

    },
    render() {}
  };
</script>


// WEBPACK FOOTER //
// src/components/maps/MarksMaps.vue